// extracted by mini-css-extract-plugin
export default {"container":"InfiniteScroll_container__5Xjoi","loader":"InfiniteScroll_loader__iOLUP"};